import React from "react";
import Footer from "../Fotter";
function PaymentPolicy() {
  return (
    <div>
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-semibold mb-4 text-gray-800">
          Pricing and Payments Policy
        </h2>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            Payment Methods
          </h3>
          <p className="text-gray-600 mb-2">
            There Are 2 Payment Options On AddMeCart Platform
          </p>
          <ul className="list-disc ml-6 text-gray-600 mb-4">
            <li>
              <strong>Prepaid</strong>: Zaakpay, FreeCharge, and mobile wallets
              (Paytm, Mobikwik).
            </li>
            <li>
              <strong>COD (Cash on Delivery)</strong>: Choose “Cash on Delivery”
              during checkout to pay in cash upon delivery.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            Fees and Payment Options
          </h3>
          <p className="text-gray-600 mb-2">
            AddMeCart does not levy any fee for browsing the platform. We offer
            several payment options, including:
          </p>
          <ul className="list-disc ml-6 text-gray-600 mb-4">
            <li>
              AddMeCart does not levy any fee for browsing the AddMeCart
              Platform. AddMeCart may in future, consider levying fees on the
              User for using the AddMeCart Platform as a whole, or for use of
              certain features of the AddMeCart Platform. In such an event, you
              agree to pay any such fees, as applicable. AddMeCart does not
              covenant or guarantee providing you with a notice prior to
              enforcing such a levy of fees. Your continued usage of the
              AddMeCart Platform after such change in the fees will be
              considered to be your acceptance of such changes.
            </li>
            <li>
              While using the Payment Options, User agrees to provide correct,
              complete and accurate financial information such as credit/debit
              card details or prepaid payment instrument account details which
              may be stored by AddMeCart third party payment gateway provider.
              User(s) shall not use a credit/debit card or prepaid instrument
              which is not lawfully owned by him/her or which the User has not
              been lawfully authorized to use. The User shall solely be
              responsible for the security and confidentiality of his/her
              financial information. AddMeCart disclaims all liabilities that
              may arise as a consequence of any unauthorized use of the User’s
              financial information and/or identity, including, details relating
              the Payment Options.
            </li>
            <li>
              AddMeCart reserves the right to impose limits on the number of
              transactions a User may undertake over the AddMeCart Platform.
              Should the User exceed such transaction limits imposed by
              AddMeCart , AddMeCart reserves the right to refuse to process
              such transactions. AddMeCart may refuse to process transactions
              emanating from User(s) who have suspicious or questionable
              transaction history on the AddMeCart Platform. Should AddMeCart
              be dissatisfied with the credibility of a User or the genuineness
              of a transaction carried out on the AddMeCart Platform,
              AddMeCart shall have the right to reject such transactions.
              AddMeCart may also choose to delay the dispatch of Products
              purchased by such User or cancel the entire purchase at its sole
              discretion. The User agrees that AddMeCart shall not be liable
              for any damage, interests or claims resulting from AddMeCart
              decision to not process a transaction or delay in the processing
              of a transaction on account of a User’s suspicious activity on the
              AddMeCart Platform.
            </li>
            <li>
              To enable User to make payments for purchasing Products on the
              AddMeCart Platform, in addition to this PPP Policy, the terms and
              conditions of the User’s bank, applicable financial institution
              and/or card issuing association may be applicable. The User’s
              bank, financial institution or card issuing association may
              decline or prevent the User from making electronic payments for
              buying the Products on the AddMeCart Platform and AddMeCart does
              not control the same and hence, shall not be at any point in time
              be held liable.
            </li>
            <li>
              If it is brought to the User’s notice that a charge has been
              created on his/her payment instrument(s) for purchase of Products
              on the AddMeCart Platform and the User is not aware of such
              purchase on the AddMeCart Platform, the User is first, required
              to verify if his/her family members, friends or business
              colleagues were authorized to carry out the purchase of Products
              on the AddMeCart Platform. If, despite this, the User continues
              to be unable to identify the charge created on his/her payment
              instrument(s) for purchase of Products on the AddMeCart Platform,
              the User may report such unauthorized purchase to us within 3
              (three) business days from the date on which the unauthorized
              purchase was carried out on the AddMeCart Platform in order to
              enable AddMeCart initiate investigations.
            </li>
            <li>
              Store Credit: If a User cancels an order for which payment has
              already been made to AddMeCart, the User shall have an option to
              convert the amount paid towards the order into store credit if
              order is cancelled by the customer support team. In addition, any
              and all refunds with respect to Products purchased through the
              ‘cash on delivery’ payment option will be transferred as store
              credit into the User’s store credit account. AddMeCart may also,
              at its sole discretion, grant User(s) with store credit. The store
              credits can be used by the User for future purchases only on the
              AddMeCart Platform. In the eventuality of a User wishing to
              deactivate his/her account with AddMeCart, the User agrees that
              all store credit available on the User’s store credit account, if
              any, will automatically stand forfeited. The User therefore agrees
              to use and exhaust any existing store credit prior to requesting
              for a deactivation of his/her account on the AddMeCart Platform.
              Notwithstanding anything to the contrary, any refund of store
              credit to the User will be at the sole discretion of AddMeCart.
              If AddMeCart suspects any fraudulent activities, AddMeCart
              reserves its right to hold back transfer of any store credits to
              User.
            </li>
            <li>
              EMI: The Equated Monthly Installment payment option allows Users
              to make staggered payments for the purchase of Products on
              Platforms as per the EMI and Additional Cashback Terms and
              Conditions. The EMI Payment option can be availed only for the
              purchase of Products on Platform with a minimum cart value as
              directed by the respective banks that offer the same. The details
              of applicable EMI option are available on every Product page. The
              EMI Payment Option is only available for payment through credit
              cards issued by selected banks as specified on the Platforms. The
              terms and conditions of the relevant banks shall be applicable on
              all payments made by Users using the EMI payment option, and
              AddMeCart will not be responsible or liable for any issues or
              claims arising from the use of these Payment Options.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            Pricing and Promotions
          </h3>
          <ul className="list-disc ml-6 text-gray-600 mb-4">
            <li>
              Product prices, offers and promotions are subject to change from
              time to time without prior notice. All prices displayed on the
              website www.addmecart.com are inclusive of taxes. AddMeCart
              reserve the right to change the prices of products, services and
              the availability of the same at our sole discretion. No refunds of
              orders will be entertained on account of price changes of the
              product on the website at any point of time.
            </li>
            <li>
              AddMeCart strives to provide accurate product and pricing
              information, however, pricing or typographical errors may occur.
              In the event that a product is listed at an incorrect price or
              with incorrect information due to an error in pricing or product
              information, AddMeCart website shall have the right, at our sole
              discretion, to refuse or cancel any orders placed for that
              product, unless the product has already been delivered.
            </li>
            <li>
              website are auto added to the shopping cart i.e. TV wall-mount
              with TV, Laptop bag or camera case with laptops/cameras wherever
              applicable. However, AddMeCart also offers bundle promotions from
              time to time which is User driven and has to be added to the cart
              by the customer.
            </li>
            <li>
              Total Invoice value will be the same as listed on the website or
              the final order value. However as per GST requirements, the Price
              of the freebie/Promotional Product will be apportioned against the
              two products on the invoice.
            </li>
          </ul>
        </section>
        <div className="mt-8 ">
          <h3 className="text-2xl font-medium text-gray-800">Contact Information</h3>
          <p className="text-lg text-gray-700 mt-2">
            <strong>AddMeCart is located at:</strong>
          </p>
          <p className="text-lg text-gray-700">Thakur Ji Ki Haweli Jalpa Mata Mandir Ke Pass Rajgarh, Rajgarh Madhya Pradesh, Bharat Pin 465661</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Phone:</strong>  08062689340</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Email:</strong> info@addmecart.com</p>
          <p className="text-lg text-gray-700 mt-2"><strong>Website:</strong> www.addmecart.com</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PaymentPolicy;
